/** Textes « corrections » — le français fait foi. */
export const corrections = {
  erreur: 'Erreur',
  titre: 'À valider',
  sousTitre: (n: number, trancher: boolean) => `${n} en attente · ${trancher ? 'vous pouvez trancher' : 'vos demandes'}`,
  videTitre: 'Rien en attente',
  videTexte: 'Aucune demande de correction à traiter.',
  minutes: (m: number) => `${m} min`,
  heures: (h: number) => `${h} h`,
  demande: (nom: string) => `${nom} demande une correction`,
  champ: (entite: string, champ: string) => `${entite} — champ « ${champ} »`,
  financiere: 'Donnée financière',
  refuser: 'Refuser',
  accorder: 'Accorder',
  enAttente: 'En attente',
  historique: 'Historique',
  colDate: 'Date', colDemandeur: 'Demandeur', colDossier: 'Dossier', colChamp: 'Champ', colDecision: 'Décision', colTraitePar: 'Traite par',
  accorderTitre: 'Accorder la correction',
  refuserTitre: 'Refuser la correction',
  commentaire: 'Commentaire',
  commentaireAide: 'Il sera conserve au journal, avec les deux valeurs.',
  annuler: 'Annuler',
};
